import { createSchema } from "starfx";
import { slice } from "starfx";
import { jgLogin } from "@app/statefx/schema/jgLogin.def";
import type { TCurrency } from "@app/types";
import type { TExecution } from "@app/types/insider";
import type { HostedOnboardingSummary } from "@app/types";
import type { IdProp } from "starfx";

import { schemaB as bp } from "@app/stateCommon/schemaBlue";

export const [schema, initialState] = createSchema({
  cache: slice.table({ empty: {} }),
  loaders: slice.loader(),
  app: slice.obj(bp.appRepo.initialState),
  appJobs: slice.table({ empty: bp.appJobs.empty }), //sb
  appProcess: slice.table({ empty: bp.appProcess.empty }),
  applog: slice.table({
    empty: bp.applog.empty,
    initialState: bp.applog.initialState,
  }), //sb
  categoryChooser: slice.obj(bp.chooserRepo.initialState), //sb
  contactlist: slice.table({ empty: bp.contactlist.empty }),
  contcatlist_num: slice.num(0),
  contractors_anaf: slice.table({ empty: bp.contractors_anaf.empty }), //sb
  contractors_anaf_num: slice.num(0),
  contractors_cff: slice.table({ empty: bp.contractors_cff.empty }), //sb
  contractors_cff_num: slice.num(0),
  contractors_temp: slice.table({ empty: bp.contractors_temp.empty }), //sb
  contractors_temp_num: slice.num(0),
  currencies: slice.any(bp.currencies.initialState), //sb
  currencyRates: slice.table({ empty: bp.currencyRates.empty }), //sb
  currencyRatesCustom: slice.table({ empty: bp.currencyRatesCustom.empty }), //sb
  dialogs: slice.obj(bp.dialogs.initialState),
  execution: slice.table({
    empty: {} as TExecution,
    initialState: {} as Record<IdProp, TExecution>,
  }),
  fs: slice.obj(bp.fsRepo.initialState), //sb , deprecated_since: 30
  fileSysHead: slice.table({ empty: bp.fileSysHead.empty }), //sb
  fileSysContent: slice.table({ empty: bp.fileSysContent.empty }), //sb
  fileSysLocalDisk: slice.table({ empty: bp.fileSysLocalDisk.empty }), //sb
  fiscalBooks: slice.table({ empty: bp.fiscalBooks.empty }), //sb
  hostedOnboardings: slice.table({ empty: {} as HostedOnboardingSummary }),
  hostedOnboardingSelection: slice.str(""),
  fsDirTree: slice.obj(bp.fsDirTree.initialState), //sb
  invoiceCollection: slice.table({ empty: bp.invoiceCollection.empty }), //sb
  invoiceIssuer: slice.table({ empty: bp.invoiceIssuer.empty }),
  invoiceFiscal: slice.table({ empty: bp.invoiceFiscal.empty }), //sb
  invoicetrack: slice.obj(bp.invoicetrackrepo.initialState), //sb
  iso3166_2: slice.table({ empty: bp.iso3166_2.empty }), //sb
  isoNewCities: slice.table({ empty: bp.isoNewCities.empty }), //sb
  issuerBankAccounts: slice.table({ empty: bp.issuerBankAccounts.empty }),
  jgLogin: slice.obj(jgLogin.initialState),
  loaderText: slice.str(""),
  loaderBootProgress: slice.num(0),
  loaderBootText: slice.str(""),
  loaderPopup: slice.any(false),
  lock: slice.str(""),
  listModels: slice.table({ empty: bp.listModels.empty }), //sb
  notify: slice.obj(bp.notifyRepo.initialState),
  OAuth2Status: slice.obj(bp.OAuth2Status.initialState),
  persistorGuardian: slice.obj(bp.persitorGuardian.initialState),
  profiles: slice.table({ empty: bp.profiles.empty }),
  profileGroup: slice.obj(bp.profileGroup.initialState),
  receiptFiscal: slice.table({ empty: bp.receiptFiscal.empty }), //sb
  signal: slice.any(new AbortController()),
  SPVInvoiceRaw: slice.table({ empty: bp.SPVInvoiceRaw.empty }), //sb
  SPVMessages: slice.table({ empty: bp.SPVMessages.empty }), //sb
  SPVMessageKeys: slice.table({ empty: bp.SPVMessageKeys.empty }), //sb
  SPVMessageUserState: slice.table({ empty: bp.SPVMessageUserState.empty }), //sb
  uiRenderKey: slice.str(""),
  uiAllotment: slice.obj(bp.uiAllotment.initialState),
  uiAllotmentCollapsed: slice.obj(bp.uiAllotmentCollapsed.initialState),
  uiContractorsEditing: slice.obj(bp.uiContractorsEditing.initialState),
  uiFiscalBooks: slice.obj(bp.uiFiscalBooks.initialState),
  uiCollectionCurrent: slice.obj(bp.uiCollectionCurrent.initialState),
  uiInvoiceCurrent: slice.obj(bp.uiInvoiceCurrent.initialState),
  uiInvoiceOverall: slice.obj(bp.uiInvoiceOverall.initialState),
  uiInvoiceEditing: slice.obj(bp.uiInvoiceEditing.initialState),
  uiJGBrowserHeader: slice.obj(bp.uiJGBrowserHeader.initialState),
  uiPersistInvoiceGrid: slice.obj(bp.uiPersistInvoiceGrid.initialState),
  uiPersistSpvList: slice.obj(bp.uiPersistSpvList.initialState),
  uiSpvGrid: slice.obj(bp.uiSpvGrid.initialState),
  uiSpvMain: slice.obj(bp.uiSpvMain.initialState),
  whoami: slice.obj(bp.whoamiRepo.initialState),
  xId: slice.num(-100), //(!)
});
